import type { WelcomePlaylistVideo, WelcomeVideoConfig } from '@/core/domain/entities/WelcomeVideo';
import { getWelcomeVideoSource } from './welcomeVideoSource';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function hasWelcomePlaylist(config: WelcomeVideoConfig | null): boolean {
  return Boolean(config && ('videos' in config || 'playlist_revision' in config));
}

/** Reject a broken new contract instead of resurrecting its legacy projection. */
export function getWelcomePlaylist(config: WelcomeVideoConfig | null): WelcomePlaylistVideo[] {
  if (!config?.enabled || !Array.isArray(config.videos) || !config.videos.length ||
    !Number.isSafeInteger(config.playlist_revision) || config.playlist_revision! < 0 ||
    typeof config.automatic_enabled !== 'boolean') return [];
  const ids = new Set<string>();
  for (const video of config.videos) {
    if (!video || typeof video !== 'object' || !UUID.test(video.id) || !UUID.test(video.media_version) ||
      ids.has(video.id) || typeof video.title !== 'string' || !video.title.trim() || video.title.length > 160 ||
      typeof video.description !== 'string' || video.description.length > 500 ||
      !Array.isArray(video.legacy_sources) || video.legacy_sources.some(alias => typeof alias !== 'string') ||
      !(video.duration_seconds === null || (Number.isFinite(video.duration_seconds) && video.duration_seconds > 0)) ||
      !getWelcomeVideoSource({ ...video, enabled: true })) return [];
    ids.add(video.id);
  }
  return typeof config.main_video_id === 'string' && ids.has(config.main_video_id) ? config.videos : [];
}
